export enum SortDirectionEnum {
  DESC = "DESC",
  ASC = "ASC",
}
